
import { Component, ChangeDetectionStrategy, inject, signal, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DataService } from '../../services/data.service';
// FIX: Corrected import path for models.
import { PortalSettings } from '../../models/index';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-portal-customizer',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './portal-customizer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalCustomizerComponent implements OnInit {
  private dataService = inject(DataService);

  settingsForm: FormGroup;

  isLoading = signal(true);
  isSaving = signal(false);
  statusMessage = signal<{ type: 'success' | 'error', text: string } | null>(null);

  constructor() {
    // FIX: Injected FormBuilder in the constructor and explicitly typed it to resolve "Property 'group' does not exist on type 'unknown'".
    const fb: FormBuilder = inject(FormBuilder);
    this.settingsForm = fb.group({
      portalName: ['CHUAMKAN Member Club', Validators.required],
      logoUrl: [''],
      primaryColor: ['#ffc107'],
      accentColor: ['#A5D6A7'],
      backgroundColor: ['#121212'],
      cardColor: ['#1f1f1f'],
      textColor: ['#EAEAEA'],
    });
  }

  ngOnInit(): void {
    this.loadSettings();
  }

  async loadSettings(): Promise<void> {
    this.isLoading.set(true);
    try {
      const settings = await this.dataService.getPortalSettings();
      if (settings) {
        this.settingsForm.patchValue(settings);
      }
    } catch (e) {
      this.statusMessage.set({ type: 'error', text: 'Failed to load settings.' });
    } finally {
      this.isLoading.set(false);
    }
  }

  async onSave(): Promise<void> {
    if (this.settingsForm.invalid) return;

    this.isSaving.set(true);
    this.statusMessage.set(null);
    try {
      await this.dataService.updatePortalSettings(this.settingsForm.value as PortalSettings);
      this.statusMessage.set({ type: 'success', text: 'Settings saved successfully!' });
      setTimeout(() => this.statusMessage.set(null), 3000);
    } catch (e) {
      this.statusMessage.set({ type: 'error', text: 'Failed to save settings.' });
    } finally {
      this.isSaving.set(false);
    }
  }
}
